import * as Yup from "yup";
import { TranslateFunction } from "../../../contexts/LocalizationContext";

export const categoryValidationSchema = (translate : TranslateFunction) => Yup.object().shape({
  id: Yup.string(),
  name: Yup.string().required(translate("validation.fieldRequired"))
});
